<div #contextMenu class="context-menu">
  <div class="context-menu__item" routerLink="/account">
    <span>Ver perfil</span>
    <mg-icons
      name="user"
      class="context-menu__item__icon-color-user"
    ></mg-icons>
  </div>
  <div
    class="context-menu__item"
    (keypress.enter)="logout()"
    (keypress.space)="logout()"
    (click)="logout()"
  >
    <span>Cerrar sesión</span>
    <mg-icons
      name="logout"
      class="context-menu__item__icon-color-logout"
    ></mg-icons>
  </div>
</div>
